export const enum Layouts {
  MODERN = 'modern',
  BOOTSTRAP = 'bootstrap',
}

const COMMON_FORM_DEFAULTS = {
  variant: 'outlined',
  density: 'comfortable',
  clearable: true,
  persistentPlaceholder: true,
} as const;

export const UI = {
  BORDER_RADIUS: 'lg',
  TEXT_FIELD_DEFAULTS: COMMON_FORM_DEFAULTS,
  TEXTAREA_DEFAULTS: COMMON_FORM_DEFAULTS,
  SELECT_DEFAULTS: COMMON_FORM_DEFAULTS,
  COMBOBOX_DEFAULTS: COMMON_FORM_DEFAULTS,
  COMBOBOX_MULTI_TAG_DEFAULTS: {
    ...COMMON_FORM_DEFAULTS,
    multiple: true,
    chips: true,
    closableChips: true,
    hideDetails: 'auto',
    delimiters: [','],
  } as const,
  AUTOCOMPLETE_DEFAULTS: {
    ...COMMON_FORM_DEFAULTS,
    hideDetails: true,
    autoSelectFirst: false,
  } as const,
};
